// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1dOV-","calendarButtons":"ClockData_calendarButtons__1gMGK"};